const initialState = {
	lastExecution: null,
	requests: [],
	audits: [],
}

export default (state = initialState, action) => {
	switch (action.type) {
		case 'LOAD_QUERIES_REQUESTS':
			return { ...state, requests: Array.isArray(action.payload) ? action.payload : [] }
		case 'ADD_QUERIES_REQUEST':
			return { ...state, lastExecution: action.response }
		case 'LOAD_QUERIES_AUDITS':
			return { ...state, audits: Array.isArray(action.payload) ? action.payload : [] }
		case 'LOGOUT':
			return initialState
		default:
			return state
	}
}
